import { useState } from 'react';
import { ButtonBasic } from "@lk-gtcom/ecomlab-components";
import no_photo from './img/not-img.svg';
import './OrderCollectCard.scss';

// НУЖНО ТЕСТИРОВАТЬ

const OrderCollectCard = ({
    posting,
    onSubmit
}) => {

    const {
        posting_number,
        api_id,
        mp_id,
        products = [],
        countries = [],
        external_order_id = [],
        photo,
        name,
    } = posting;

    // external_order_id — массив, элементов с additional_info_required: true
    // может быть НЕСКОЛЬКО (например, разные внешние идентификаторы).
    const externalOrderFields = external_order_id.filter((item) => item.additional_info_required);

    // Ключ товара для хранения состояния (маркировка/страна)
    const getProductKey = (product, idx) => product.sku ?? product.offer_id ?? idx;

    // Ключ поля внешнего ID
    const getExternalFieldKey = (field, idx) => field.title ?? idx;

    const [markingCodes, setMarkingCodes] = useState({}); // { [productKey]: string[] }
    const [selectedCountries, setSelectedCountries] = useState({}); // { [productKey]: string }
    const [externalOrderValues, setExternalOrderValues] = useState({}); // { [fieldKey]: string }
    const [submitted, setSubmitted] = useState(false);

    const getMarks = (key, quantity) =>
        markingCodes[key] ?? Array.from({ length: quantity || 1 }, () => '');

    const handleMarkChange = (key, quantity, idx, value) => {
        const current = getMarks(key, quantity);
        const updated = current.map((v, i) => (i === idx ? value : v));
        setMarkingCodes((prev) => ({ ...prev, [key]: updated }));
    };

    const handleCountryChange = (key, value) => {
        setSelectedCountries((prev) => ({ ...prev, [key]: value }));
    };

    const handleExternalFieldChange = (fieldKey, value) => {
        setExternalOrderValues((prev) => ({ ...prev, [fieldKey]: value }));
    };

    // Проверка заполненности всех обязательных полей
    const isValid = () => {
        const externalFieldsFilled = externalOrderFields.every((field, idx) => {
            const fieldKey = getExternalFieldKey(field, idx);
            return (externalOrderValues[fieldKey] ?? '').trim();
        });
        if (!externalFieldsFilled) return false;

        return products.every((product, idx) => {
            const key = getProductKey(product, idx);

            if (product.country_required && !selectedCountries[key]) return false;

            if (product.mandatory_mark_required) {
                const marks = getMarks(key, product.quantity);
                if (marks.some((mark) => !mark.trim())) return false;
            }

            return true;
        });
    };

    const handleSubmit = () => {
        if (!isValid()) return;

        onSubmit?.({
            api_id,
            mp_id,
            posting_number,
            products: products.map((product, idx) => {
                const key = getProductKey(product, idx);
                return {
                    quantity: product?.quantity,
                    product_id: product.sku,
                };
            })
        });

        setSubmitted(true);
    };

    return (
        <div className={`order-collect-card ${submitted ? 'order-collect-card--submitted' : ''}`}>
            {/* Общая информация об отправлении: фото/название первого товара
                в ответе API + номер отправления. Не заменяет карточки
                отдельных товаров ниже, а даёт контекст "что за посылка". */}
            <div className='order-collect-card__general'>
                <div className='order-collect-card__photo'>
                    <img
                        className={photo ? 'order-collect-card__img' : ''}
                        alt={name ?? 'Отправление'}
                        src={photo || no_photo}
                        onError={(e) => (e.currentTarget.src = no_photo)}
                    />
                </div>
                <div className='order-collect-card__general-info'>
                    {name &&
                        <p className='order-collect-card__general-name'>{name}</p>
                    }
                    <div className='order-collect-card__ids'>
                        <span>Отправление: <strong>{posting_number}</strong></span>
                        <span>Товаров: <strong>{products.length}</strong></span>
                    </div>
                </div>
            </div>

            <div className='order-collect-card__products'>
                {products.map((product, idx) => {
                    const key = getProductKey(product, idx);
                    const marks = getMarks(key, product.quantity);

                    return (
                        <div className='order-collect-card__product' key={key}>
                            <div className='order-collect-card__product-main'>
                                <div className='order-collect-card__photo'>
                                    <img
                                        className={product.photo ? 'order-collect-card__img' : ''}
                                        src={product.photo || no_photo}
                                        onError={(e) => (e.currentTarget.src = no_photo)}
                                        alt={product.name} />
                                </div>
                                <div className='order-collect-card__product-info'>
                                    <p className='order-collect-card__name'>{product.name}</p>
                                    <div className='order-collect-card__ids'>
                                        <span>Арт.: <strong>{product.offer_id}</strong></span>
                                        {product.quantity > 1 &&
                                            <span>Кол-во: <strong>{product.quantity}</strong></span>
                                        }
                                    </div>
                                </div>
                            </div>

                            {product.country_required && (
                                <div className='order-collect-card__field'>
                                    <label className='order-collect-card__field-label'>
                                        Страна производства
                                    </label>
                                    {countries.length > 0 ? (
                                        <select
                                            className='order-collect-card__select'
                                            value={selectedCountries[key] ?? ''}
                                            onChange={(e) => handleCountryChange(key, e.target.value)}
                                            disabled={submitted}
                                        >
                                            <option value='' disabled>Выберите страну</option>
                                            {countries.map((country) => (
                                                <option key={country} value={country}>{country}</option>
                                            ))}
                                        </select>
                                    ) : (
                                        <input
                                            type='text'
                                            className='order-collect-card__input'
                                            placeholder='Укажите страну производства'
                                            value={selectedCountries[key] ?? ''}
                                            onChange={(e) => handleCountryChange(key, e.target.value)}
                                            disabled={submitted}
                                        />
                                    )}
                                </div>
                            )}

                            {product.mandatory_mark_required && (
                                <div className='order-collect-card__field'>
                                    <label className='order-collect-card__field-label'>
                                        Код маркировки {marks.length > 1 ? `(${marks.length} шт.)` : ''}
                                    </label>
                                    <div className='order-collect-card__marks'>
                                        {marks.map((mark, markIdx) => (
                                            <input
                                                key={markIdx}
                                                type='text'
                                                className='order-collect-card__input'
                                                placeholder='Введите код'
                                                value={mark}
                                                onChange={(e) =>
                                                    handleMarkChange(key, product.quantity, markIdx, e.target.value)
                                                }
                                                disabled={submitted}
                                            />
                                        ))}
                                    </div>
                                </div>
                            )}
                        </div>
                    );
                })}
            </div>

            {externalOrderFields.map((field, idx) => {
                const fieldKey = getExternalFieldKey(field, idx);
                return (
                    <div className='order-collect-card__field' key={fieldKey}>
                        <label className='order-collect-card__field-label'>
                            {field.title}
                        </label>
                        <input
                            type='text'
                            className='order-collect-card__input'
                            placeholder='Введите значение'
                            value={externalOrderValues[fieldKey] ?? ''}
                            onChange={(e) => handleExternalFieldChange(fieldKey, e.target.value)}
                            disabled={submitted}
                        />
                    </div>
                );
            })}

            {!submitted ? (
                <ButtonBasic
                    blue
                    width='100%'
                    text='Собрать заказ'
                    onClick={handleSubmit}
                    disabled={!isValid()}
                />
            ) : (
                <div className='order-collect-card__success'>
                    ✓ Заказ собран
                </div>
            )}
        </div>
    );
};

export { OrderCollectCard };
